<template>
    <div>
        <div class="relative">
            <img class="banner" :src="harbor.banner"/>
            <div class="title">
                <h1>{{ harbor.banner_title }}</h1>
                <h2>{{ harbor.banner_title_en }}</h2>
            </div>

            <div class="main-width absolute bread py-5">
                <VBreadcrumb :options="[
                    { label: '首页', to: '/' },
                    { label: '全部热门港口' }
                ]" theme="white"></VBreadcrumb>
            </div>
        </div>
        <section class="box">
            <div class="main-width">
               <div class="citys">
                    <a :href="cityLink(city.id)" v-for="city in harbor.list" :key="city.id" target="_blank">
                        <div class="city">
                            <div class="city-inner">
                                <div class="poster-box">
                                    <img class="poster" :src="city.images" />
                                </div>
                                <h3 class="name">
                                    {{ city.shortname }} <span class="en">{{ city.pinyin }}</span>
                                </h3>
                                <p class="desc">{{ city.desc }}</p>
                            </div>
                        </div>
                    </a>
               </div>
            </div>
        </section>
    </div>
</template>
<script>
import { defineComponent, useMeta } from '@nuxtjs/composition-api';
import { getHotHarbor } from "@/services/harbor";
import VBreadcrumb from '@/components/VBreadcrumb.vue'

export default defineComponent({
    name: 'harborCity',
    auth: false,
    head: {},
    layout: 'Main',
    components:{VBreadcrumb},
    setup() {
		useMeta(() => ({
			title: "热门港口"
		}));
    },
    data(){
        return {
            harbor:{}
        }
    },
    methods:{
        cityLink(id){
            return '/harbor/city?id='+id
        },
    },
    async fetch(){
        const { data, code, msg } = await getHotHarbor()
        if (code === 10000 || code === 200) {
            this.harbor = data
        } else {
            this.$message({
                type: "error",
                text: msg
            });
        }
    }
})
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 280px;
  display: block;
  object-fit: cover;
}
.title {
  text-align: center;
  color: #fff;
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  padding-top: 85px;
}
.title h1 {
  font-size: 52px;
  font-weight: 500;
  margin-bottom: 4px;
}
.title h2 {
  font-size: 26px;
}
.bread {
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 1;
}
.box {
  background-color: #fff;
  padding-bottom: 30px;
  padding-top: 60px;
}
.citys {
  overflow: hidden;
  margin-right: -22px;
}
.citys .city {
  width: 33.33%;
  height: 352px;
  margin-bottom: 50px;
  float: left;
  padding-right: 22px;
}
.citys .city .poster-box {
  width: 100%;
  height: 240px;
  overflow: hidden;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.1);
}
.citys .city .poster {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s;
}
.citys .city .poster:hover {
  transform: scale(1.2);
}
.citys .city .name {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 8px;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.citys .city .en {
  font-size: 16px;
  font-weight: normal;
  color: $color-black-2;
}
.citys .city .desc {
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  --tw-text-opacity: 1;
  color: rgba(96, 99, 112, var(--tw-text-opacity));
}
</style>
